// @ts-check
import React, { Component } from 'react';
import cx from 'classnames';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';
import Modal from 'shared/components/Modal';
import PropTypes from 'prop-types';
import HForm, { SelectInput } from 'shared/containers/portal_layout/HForm';
import { inlineReduxForm } from 'utils/reduxFormWrapper';
import { decamelizeKeys } from 'humps';
import styles from './IndexPage.module.scss';
import FlashMessageActions from 'shared/actions/FlashMessageActions';

const Wrapper = props => {
  return (
    <Page title="Providers">
      <Row>
        <Widget title="Providers" span={12}>
          <IndexPage {...props} />
        </Widget>
      </Row>
    </Page>
  );
};

export default Wrapper;

class IndexPage extends Component {
  constructor() {
    super();
    this.state = {
      openModal: null,
      providers: null,
      providerId: null,
    };
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleSuccessfulModal = this.handleSuccessfulModal.bind(this);
  }

  hideModal() {
    this.setState({ openModal: null });
  }

  showModal(name, providerId) {
    this.setState({ openModal: name, providerId });
  }

  handleSuccessfulModal() {
    this.refresh();
    this.hideModal();
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    api
      .get(`/agent_portal/api/organizations/${this.props.params.organization_id}/providers`)
      .then(response => {
        this.setState({ providers: response.data });
      });
  }

  render() {
    if (!this.state.providers) return <LoadingContent />;

    const provider = this.state.providers.find(provider => provider.id === this.state.providerId);

    return (
      <div>
        <Modals
          provider={provider}
          handleSuccess={this.handleSuccessfulModal}
          hideModal={this.hideModal}
          openModal={this.state.openModal}
        />
        <table className="table table-bordered table-striped" data-spec-id="providers">
          <thead>
            <tr>
              <th>Name</th>
              <th>Locations</th>
              <th>Specialties</th>
            </tr>
          </thead>
          <tbody>
            {this.state.providers.map(provider => (
              <tr
                key={provider.providerEmploymentId}
                data-spec-id={`row-${provider.providerEmploymentId}`}
              >
                <td>{provider.name}</td>
                <td>{provider.locationNames.join(', ')}</td>
                <td>
                  {provider.specialtyNames.join(', ')} (
                  <span
                    className="fake-link"
                    onClick={() => this.showModal('specialties', provider.id)}
                  >
                    Change
                  </span>
                  )
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const Modals = props => {
  if (!props.provider) return null;
  return (
    <div className="visible-overflow">
      <Modal
        className="visible-overflow"
        show={props.openModal === 'specialties'}
        onHide={props.hideModal}
      >
        <ProviderSpecialties provider={props.provider} handleSuccess={props.handleSuccess} />
      </Modal>
    </div>
  );
};

Modals.propTypes = {
  handleSuccess: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
};

class ProviderSpecialties extends Component {
  constructor() {
    super();
    this.state = { specialties: null };
    this.updateSpecialties = this.updateSpecialties.bind(this);
  }

  componentDidMount() {
    this.fetchSpecialties();
  }

  updateSpecialties(formValues) {
    api
      .put(
        `/agent_portal/api/providers/${this.props.provider.id}/specialties`,
        decamelizeKeys(formValues)
      )
      .then(response => {
        FlashMessageActions.flashSuccess({
          message: "You have successfully updated the provider's specialties",
        });
        return this.props.handleSuccess();
      });
  }

  fetchSpecialties() {
    api.get(`/shared/api/standard_specialties`).then(response => {
      this.setState({ specialties: response.data });
    });
  }

  render() {
    if (!this.state.specialties)
      return (
        <div style={{ padding: '10px' }}>
          <LoadingContent />
        </div>
      );
    const { provider } = this.props;
    return inlineReduxForm(
      { form: 'providerSpecialties', initialValues: { specialtyIds: provider.specialtyIds } },
      formProps => (
        <HForm onSubmit={formProps.handleSubmit(this.updateSpecialties)}>
          <div style={{ marginTop: '5px' }}>
            <div className="modal-header">Edit Specialties for {provider.name}</div>
            <div className={cx('modal-body', styles.modalBody)}>
              <p>
                Please add or remove specialties below. You can search by typing a few letters, and
                you can select more than one.
              </p>
              <SelectInput
                name="specialtyIds"
                label="Specialties"
                placeholder="Type your specialty names..."
                options={this.state.specialties}
                valueKey="id"
                labelKey="name"
                multi
                simpleValue="simpleArray"
                isLoading={this.state.specialties === null}
                className={styles.styledSelect}
              />
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </HForm>
      )
    );
  }
}

ProviderSpecialties.propTypes = {
  provider: PropTypes.object.isRequired,
  handleSuccess: PropTypes.func.isRequired,
};
